import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateNotificationsState from './notification';
import updateSubscriptionsState from '../subscriptions/state/subscription';
import updateAnnouncementsState from '../announcements/state/announcement';
import updateSubscribersState from '../subscribers/state/subscriber';
import updateDatasetState from '../subscribers/state/dataset';

const handlers = {
  ...updateNotificationsState,
  ...updateSubscriptionsState,
  ...updateAnnouncementsState,
  ...updateSubscribersState,
  ...updateDatasetState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
